module.exports = __webpack_public_path__ + "img/img_gongyouyun.8d30a7df.png";